import { Pagination } from "react-bootstrap";

const PaginationComponent = ({
  currentPage,
  setCurrentPage,
  totalData,
  onPageChange,
  limit,
  route,
}) => {
  const totalPages = Math.ceil(totalData / limit);

  const items = [];

  // Function to create page items
  const createPaginationItems = () => {
    if (totalPages <= 5) {
      for (let number = 1; number <= totalPages; number++) {
        items.push(
          <Pagination.Item
            key={number}
            active={currentPage === number - 1}
            onClick={() => onPageChange(number)}
          >
            {number}
          </Pagination.Item>
        );
      }
    } else {
      // First page

      items.push(
        <Pagination.Item
          key={1}
          active={currentPage === 0}
          onClick={() => onPageChange(1)}
        >
          1
        </Pagination.Item>
      );

      // Ellipsis after the first page
      if (currentPage > 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-1" />);
      }

      // Current page and surrounding pages
      const start = Math.max(1, currentPage - 1);
      const end = Math.min(totalPages, currentPage + 1);

      for (let number = start; number <= end; number++) {
        if (number !== 1 && number !== totalPages) {
          items.push(
            <Pagination.Item
              key={number}
              active={currentPage === number - 1}
              onClick={() => onPageChange(number)}
            >
              {number}
            </Pagination.Item>
          );
        }
      }

      // Ellipsis before the last page
      if (currentPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-2" />);
      }

      // Last page
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages - 1}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }
  };

  createPaginationItems();

  return (
    <>
      {totalPages > 1 && (
        <Pagination>
          
          <Pagination.First
            disabled={currentPage === 0}
            onClick={() => onPageChange(1)}
          />

          
          <Pagination.Prev
            disabled={currentPage === 0}
            onClick={() => onPageChange(currentPage)}
          />

          
          {items}

          
          <Pagination.Next
            disabled={currentPage === totalPages - 1}
            onClick={() => onPageChange(currentPage + 2)}
          />

          
          <Pagination.Last
            disabled={currentPage === totalPages - 1}
            onClick={() => onPageChange(totalPages)}
          />
        </Pagination>
      )}
    </>
  );
};

export default PaginationComponent;
